import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCalculation = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M21.678 1.435h-18a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-20a1 1 0 0 0-1-1Zm-4.374 1.683v3.697l-.74-.27c-.284-.143-.96-.143-1.242 0l-.768.27V3.118h2.75ZM4.409 21.682V2.99H6.41v18.693H4.41Zm16.683.029h-12.9V3.051h4.52v5.15a1.048 1.048 0 0 0 1.518.933l1.624-.807 1.624.807a1.048 1.048 0 0 0 1.026-.042c.307-.192.494-.529.493-.89V2.962h2.095v18.748Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCalculation)
const Memo = memo(ForwardRef)
export default Memo
